import { render, staticRenderFns } from "./TresholdSlider.vue?vue&type=template&id=659e889e&scoped=true"
import script from "./TresholdSlider.vue?vue&type=script&lang=js"
export * from "./TresholdSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659e889e",
  null
  
)

export default component.exports